module.exports = __webpack_public_path__ + "img/btn_close.df4cacdb.png";